import { cva, type VariantProps } from 'class-variance-authority'

/**
 * Superfície canônica de controles 30–48px — MASTER §7 L6.
 * Borda clara (`border-contour`), não `gray-600` / `--color-input`.
 */
export const controlSurfaceClasses = [
  'border-2 border-contour bg-white shadow-sm',
  'text-gray-900 placeholder:text-gray-500',
  'transition-colors',
  'focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/20',
  'disabled:cursor-not-allowed disabled:opacity-50',
  'aria-[invalid=true]:border-danger aria-[invalid=true]:focus:ring-danger/20'
] as const

/**
 * Estilo base dos controles de formulário.
 *
 * A altura, o raio e o padding vêm dos tokens `--control-*`, os mesmos que o
 * `Button` consome. É isso que faz um campo e um botão de mesmo `size` fecharem
 * a mesma linha sem ajuste manual — ver MASTER §4.
 *
 * O tamanho de fonte é 16px no mobile de propósito: o Safari no iOS amplia a
 * página ao focar um campo com fonte menor que isso. No desktop cai para 14px,
 * onde o zoom não existe. É o mesmo padrão do registry shadcn.
 */
export const controlVariants = cva(['w-full', ...controlSurfaceClasses], {
  variants: {
    size: {
      sm: 'h-[var(--control-h-sm)] rounded-[var(--control-r-sm)] px-2.5 text-base md:text-sm',
      md: 'h-[var(--control-h-md)] rounded-[var(--control-r-md)] px-3 text-base md:text-sm',
      lg: 'h-[var(--control-h-lg)] rounded-[var(--control-r-lg)] px-3.5 text-base md:text-sm'
    }
  },
  defaultVariants: {
    size: 'md'
  }
})

export type ControlSize = NonNullable<VariantProps<typeof controlVariants>['size']>

/**
 * Área de texto: mesma linguagem visual, sem altura fixa — a altura de controle
 * não se aplica a um campo que cresce em linhas.
 */
export const textareaVariants = cva([
  'w-full',
  ...controlSurfaceClasses,
  'rounded-[var(--control-r-md)] px-3 py-2.5 text-base md:text-sm'
])
